// extracted by mini-css-extract-plugin
export default {"position":"LKe9E3jv","position--left":"pVhkveM0","position--center":"LAutA0RY","position--right":"NF582CKR"};